// Browser detection for when you get desparate. A measure of last resort.
// http://rog.ie/post/9089341529/html5boilerplatejs

// var b = document.documentElement;
// b.setAttribute('data-useragent',  navigator.userAgent);
// b.setAttribute('data-platform', navigator.platform);

// sample CSS: html[data-useragent*='Chrome/13.0'] { ... }


// remap jQuery to $
(function ($) {

    /* trigger when page is ready */
    $(document).ready(function () {



        // function adjustBackgroundSize() {
        //     var containerWidth = document.querySelector('.block-left').offsetWidth * 2;
        //     var columns = document.querySelectorAll('.bg-image');

        //     columns.forEach(function (column) {
        //         column.style.backgroundSize = containerWidth + 'px auto';
        //     });
        // }

        // // Adjust on resize
        // window.addEventListener('resize', adjustBackgroundSize);

        // // Initial adjust
        // adjustBackgroundSize();


        safari100vhHack();
        //convertSvg()

        if ($('.page-template-tpl-landing-page').length && $('.panel').length) {
            $(window).on('resize', function () {
                if ($(window).width() < 577) {
                    $('.wrapper .panel').first().css('padding-top', '60px');
                } else {
                    $('.wrapper .panel').first().css('padding-top', '');
                }
            }).trigger('resize');
        }

        // ----------------------------------------------------------- MENU
        $('#hamburger').on('click', function () {
            $(this).toggleClass('menu-open');
            $('#menuWrap').toggleClass('menu-open');
            $('html').toggleClass('overflow');
        // The toggle is a real button now, so its expanded state must be reported.
        $(this).attr('aria-expanded', $(this).hasClass('menu-open') ? 'true' : 'false');
        })
        // ----------------------------------------------------------- MENU

        // ----------------------------------------------------------- NEW HOMEPAGE / STONE TAXONOMY STICKY HEADER
        if ($('body').hasClass('page-template-tpl-home-new') || $('body').hasClass('tax-stone') || $('body').hasClass('page-template-tpl-application')) {
            var $homeBody = $('body');
            var toggleHomeScrolled = function () {
                $homeBody.toggleClass('home-scrolled', window.scrollY > 10);
            };
            toggleHomeScrolled();
            window.addEventListener('scroll', toggleHomeScrolled, { passive: true });
        }
        // ----------------------------------------------------------- NEW HOMEPAGE / STONE TAXONOMY STICKY HEADER


        // ----------------------------------------------------------- HOME
        if ($('.swiperHome').length) {

            var swiperWords = new Swiper('.swiperWords', {
                // Swiper owns image loading for its own slides: the images keep the
                // browser's loading="lazy" and this preloads the slides either side, so
                // the next one is ready before the swipe rather than appearing after it.
                lazyPreloadPrevNext: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                speed: 200,
                allowTouchMove: false,
                mousewheel: false,
                loop: true,


            });

            var swiperHome = new Swiper('.swiperHome', {
                // Swiper owns image loading for its own slides: the images keep the
                // browser's loading="lazy" and this preloads the slides either side, so
                // the next one is ready before the swipe rather than appearing after it.
                lazyPreloadPrevNext: 1,
                direction: 'vertical',
                speed: 600,
                allowTouchMove: false,
                mousewheel: true,
                loop: true,
                autoplay: false,
                // on: {
                //     slideChange: function () {
                //         swiperWords.slideNext();
                //     }
                // }

            });
        }

        if ($('.page-template-tpl-home').length && $('.swiperHome').length) {

            setTimeout(function () {
                $('.logo-wrap').addClass('show')
            }, 1000);

            setTimeout(function () {
                $('.swiperHome').addClass('show')
            }, 3000);

            setTimeout(function () {
                $('.logo-wrap').removeClass('show')
                $('.swiperWords').addClass('show')

                swiperHome.params.autoplay = {
                    delay: 4500,
                    disableOnInteraction: false
                };
                swiperHome.autoplay.start();
                swiperWords.params.autoplay = {
                    delay: 1500,
                    disableOnInteraction: false
                };
                swiperWords.autoplay.start();

            }, 4000);


            $('.swiperWords').on('click', function () {
                window.location.href = "/products";
            })

        }



        // ----------------------------------------------------------- HOME

        if ($('.swiperHomeApplications').length) {
            $('.swiperHomeApplications').each(function () {
                new Swiper(this, {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    speed: 600,
                    slidesPerView: 'auto',
                    watchOverflow: true,
                    grabCursor: true,
                    spaceBetween: 40,
                    breakpoints: {
                        0: {
                            spaceBetween: 12
                        },
                        641: {
                            spaceBetween: 40
                        }
                    }
                });
            });
        }

        if ($('.swiperHomeJourney').length) {
            $('.swiperHomeJourney').each(function () {
                var $section = $(this).closest('.brand-story');
                var slideCount = $section.find('.swiper-slide').length;

                new Swiper(this, {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    speed: 600,
                    loop: slideCount > 1,
                    allowTouchMove: slideCount > 1,
                    watchOverflow: true,
                    navigation: {
                        nextEl: $section.find('.brand-story-next')[0],
                        prevEl: $section.find('.brand-story-prev')[0],
                    }
                });
            });
        }

        if ($('.swiperHomeProjects').length) {
            $('.swiperHomeProjects').each(function () {
                var $section = $(this).closest('.projects');
                var slideCount = $section.find('.swiper-slide').length;

                new Swiper(this, {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    speed: 600,
                    slidesPerView: 1,
                    loop: slideCount > 1,
                    allowTouchMove: slideCount > 1,
                    watchOverflow: true,
                    grabCursor: slideCount > 1,
                    navigation: {
                        nextEl: $section.find('.project-next')[0],
                    },
                    pagination: {
                        el: $section.find('.project-pagination')[0],
                        clickable: true,
                    }
                });
            });
        }

        if ($('.swiperHomeJournal').length) {
            $('.swiperHomeJournal').each(function () {
                var $section = $(this).closest('.blog');

                new Swiper(this, {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    speed: 600,
                    slidesPerView: 'auto',
                    watchOverflow: true,
                    grabCursor: true,
                    spaceBetween: 24,
                    navigation: {
                        nextEl: $section.find('.blog-next')[0],
                        prevEl: $section.find('.blog-prev')[0],
                    },
                    breakpoints: {
                        0: {
                            spaceBetween: 20
                        },
                        641: {
                            spaceBetween: 24
                        }
                    }
                });
            });
        }

        if ($('.swiperAbodaAutoCarousel').length) {
            $('.swiperAbodaAutoCarousel').each(function () {
                var $section = $(this).closest('.stone-carousel-section');
                var desktopSpace = parseInt($(this).attr('data-space-desktop'), 10) || 24;
                var mobileSpace = parseInt($(this).attr('data-space-mobile'), 10) || 20;

                new Swiper(this, {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    speed: 600,
                    slidesPerView: 'auto',
                    watchOverflow: true,
                    grabCursor: true,
                    spaceBetween: desktopSpace,
                    navigation: {
                        nextEl: $section.find('.stone-carousel-next')[0],
                        prevEl: $section.find('.stone-carousel-prev')[0],
                    },
                    breakpoints: {
                        0: {
                            spaceBetween: mobileSpace
                        },
                        641: {
                            spaceBetween: desktopSpace
                        }
                    }
                });
            });
        }

        // ----------------------------------------------------------- APPLICATION INNER PAGE GALLERY
        // Separate from swiperAbodaAutoCarousel because this one needs fraction
        // pagination for the "n/total" counter; keeping it apart means the stone
        // landing carousels are untouched.

        if ($('.swiperApplicationGallery').length) {
            $('.swiperApplicationGallery').each(function () {
                var $shell = $(this).closest('.application-gallery-shell');
                var $captions = $shell.find('.application-gallery-caption');

                // Slides hold only the image, so the caption below is switched
                // to match the active slide. Matching is on data-slide-index
                // rather than DOM position, so it holds even if the markup ever
                // stops emitting one caption per slide.
                var syncCaption = function (index) {
                    $captions.each(function (captionIndex) {
                        var slideIndex = $(this).attr('data-slide-index');
                        slideIndex = (typeof slideIndex === 'undefined') ? captionIndex : parseInt(slideIndex, 10);
                        $(this).toggleClass('is-active', slideIndex === index);
                    });
                };

                var gallery = new Swiper(this, {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    speed: 600,
                    slidesPerView: 'auto',
                    watchOverflow: true,
                    grabCursor: true,
                    spaceBetween: 40,
                    navigation: {
                        nextEl: $shell.find('.application-gallery-next')[0],
                        prevEl: $shell.find('.application-gallery-prev')[0],
                    },
                    pagination: {
                        el: $shell.find('.application-gallery-counter')[0],
                        type: 'fraction',
                    }
                });

                if ($captions.length) {
                    gallery.on('slideChange', function () {
                        syncCaption(gallery.realIndex);
                    });
                    syncCaption(gallery.realIndex);
                }
            });
        }


        // ----------------------------------------------------------- PRODUCTS CATEGORY PAGE + PROJECTS PAGE

        if ($('.swiperTaxonomies').length) {
            const swiper = new Swiper('.swiperTaxonomies', {
                // Swiper owns image loading for its own slides: the images keep the
                // browser's loading="lazy" and this preloads the slides either side, so
                // the next one is ready before the swipe rather than appearing after it.
                lazyPreloadPrevNext: 1,
                direction: 'vertical',
                speed: 800,
                allowTouchMove: false,
                mousewheel: true,
                on: {
                    slideChange: function (swiper) {
                        var targetIndex = swiper.activeIndex;
                        //console.log('Next slide index is: ' + targetIndex);

                        $('.active-category').removeClass('active-category')
                        $('[data-imageIndex="' + targetIndex + '"]').addClass('active-category')
                    }
                }
            });
            $('.terms-list li a').hover(
                function () {
                    $('.active-category').removeClass('active-category')
                    $(this).addClass('active-category')

                    var imageIndex = $(this).attr('data-imageIndex')
                    swiper.slideTo(imageIndex)
                }
            );
        }
        if ($('.swiperProjects').length) {
            const swiper = new Swiper('.swiperProjects', {
                // Swiper owns image loading for its own slides: the images keep the
                // browser's loading="lazy" and this preloads the slides either side, so
                // the next one is ready before the swipe rather than appearing after it.
                lazyPreloadPrevNext: 1,
                direction: 'vertical',
                speed: 800,
                allowTouchMove: false,
                mousewheel: true,
                on: {
                    slideChange: function (swiper) {
                        var targetIndex = swiper.activeIndex;
                        //console.log('Next slide index is: ' + targetIndex);

                        $('.active-project').removeClass('active-project')
                        $('[data-imageIndex="' + targetIndex + '"]').addClass('active-project')
                    }
                }
            });
            $('.projects-list li a').hover(
                function () {
                    $('.active-project').removeClass('active-project')
                    $(this).addClass('active-project')

                    var imageIndex = $(this).attr('data-imageIndex')
                    swiper.slideTo(imageIndex)
                }
            );
        }

        // ----------------------------------------------------------- PRODUCTS CATEGORY PAGE + PROJECTS PAGE


        // ----------------------------------------------------------- PRODUCT PAGE

        if ($('.swiperProduct').length > 0) {
            const breakpoint = window.matchMedia('(max-width:1024px)');
            let mySwiper;

            const breakpointChecker = function () {

                if (breakpoint.matches === true) {

                    if (mySwiper !== undefined) mySwiper.destroy(true, true);
                    return;

                } else if (breakpoint.matches === false) {
                    return enableSwiper();
                }

            };

            const enableSwiper = function () {
                mySwiper = new Swiper(".swiperProduct", {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    direction: 'vertical',
                    allowTouchMove: false,
                    speed: 800,
                    mousewheel: true,
                    cssMode: false,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },

                });
            };

            breakpoint.addListener(breakpointChecker);
            breakpointChecker();

            $('.section-1-button, .section-2-button').on('click', function () {
                mySwiper.slideNext()
            })

            let imgWrap = $(".slab-image-wrap")
            $(imgWrap).mousemove(function (event) {
                var x = event.pageX - $(this).offset().left;
                var y = event.pageY - $(this).offset().top;
                $(".slab-image-wrap .follow-img").css('left', `${x}px`)
                $(".slab-image-wrap .follow-img").css('top', `${y}px`)
            });

        }


        // REQUEST SAMPLE FORM
        if ($('.form-wrap .close').length) {
            $('.form-wrap .close').on('click', function () {
                $('.form-background').fadeOut()
            })

            $(document).mouseup(function (e) {
                if ($('.form-background').is(":visible")) {
                    var container = $(".form-background .form-wrap");
                    // if the target of the click isn't the container nor a descendant of the container
                    if (!container.is(e.target) && container.has(e.target).length === 0) {
                        $('.form-background').fadeToggle();
                    }
                }
            });

        }

        if ($('.request-sample').length) {
            $('.request-sample').on('click', function () {
                $('.form-background').fadeIn()
            })
        }

        // SHOWROOM POPUP — reuses the .form-background modal (close handled by the block above)
        if ($('.cta-button').length) {
            $('.cta-button').on('click', function () {
                $('.aboda-showroom-popup').fadeIn()
            })
        }
        // REQUEST SAMPLE FORM


        // IAMGE POPUP
        if ($('.image-popup .close').length) {
            $('.image-popup .close').on('click', function () {
                $('.image-popup').fadeOut()
            })

            $(document).mouseup(function (e) {
                if ($('.image-popup').is(":visible")) {
                    var container = $(".image-popup img");
                    // if the target of the click isn't the container nor a descendant of the container
                    if (!container.is(e.target) && container.has(e.target).length === 0) {
                        $('.image-popup').fadeToggle();
                    }
                }
            });

        }


        if ($('.slide-3').length) {
            $('.slide-3 img').on('click', function () {
                $('.image-popup').fadeIn()
            })
        }
        // IAMGE POPUP

        // ----------------------------------------------------------- PRODUCT PAGE

        // ----------------------------------------------------------- PROJECT PAGE

        if ($('.swiperProject').length > 0) {

            const breakpoint = window.matchMedia('(max-width:1024px)');
            let mySwiper;

            const breakpointChecker = function () {

                if (breakpoint.matches === true) {

                    if (mySwiper !== undefined) mySwiper.destroy(true, true);
                    return;

                } else if (breakpoint.matches === false) {
                    return enableSwiper();
                }

            };

            const enableSwiper = function () {
                mySwiper = new Swiper(".swiperProject", {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    direction: 'vertical',
                    allowTouchMove: false,
                    speed: 800,
                    mousewheel: true,
                    cssMode: false,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    on: {
                        slideChange: function (swiper) {
                            var previousIndex = swiper.previousIndex;
                            var activeIndex = swiper.activeIndex;
                            if (activeIndex == 0 || previousIndex == 0) {
                                $('.block-left .product-title').toggleClass('move-title');
                            }

                        }
                    }

                });
            };

            breakpoint.addListener(breakpointChecker);
            breakpointChecker();


            $('.block-left, .block-right .swiperProject').on('click', function () {
                //console.log(mySwiper.activeIndex);
                if (mySwiper.activeIndex == 0) {
                    mySwiper.slideNext()
                }
            })

            // MOUSE SCROLL ON LEFT SIDE OF THE SCREEN
            // var isMouseOverLeftSide = false;
            // $('.block-left').on('mouseenter', function () {
            //     isMouseOverLeftSide = true;
            // }).on('mouseleave', function () {
            //     isMouseOverLeftSide = false;
            // });

            // $(window).on('wheel', function (e) {
            //     console.log('wheel');
            //     if (isMouseOverLeftSide) {
            //         var delta = e.originalEvent.deltaY;

            //         if (delta > 0) {
            //             // going down
            //             console.log('going down');
            //             mySwiper.slideNext()
            //         }
            //         else {
            //             // going up
            //             console.log('going up');
            //             mySwiper.slidePrev()
            //         }
            //     }

            //     return false;
            // });

        }


        // if only one slider
        /*
        if ($('.slideshowSwiper').length > 0) {

            const breakpointSlideshow = window.matchMedia('(max-width:767px)');

            var slideshowSwiper;

            const breakpointSlideshowChecker = function () {

                if (breakpointSlideshow.matches === true) {

                    if (slideshowSwiper !== undefined) slideshowSwiper.destroy(true, true);
                    return;

                } else if (breakpointSlideshow.matches === false) {
                    return enableSlideshowSwiper();
                }

            };

            const enableSlideshowSwiper = function () {
                slideshowSwiper = new Swiper(".slideshowSwiper", {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    loop: true,
                    speed: 1000,
                    spaceBetween: 20,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        nextEl: ".swiper-arrow-next",
                        prevEl: ".swiper-arrow-prev",
                    },
                    pagination: {
                        el: ".swiper-slideshow-pagination",
                        clickable: true,
                    }
                });


            };

            breakpointSlideshow.addListener(breakpointSlideshowChecker);
            breakpointSlideshowChecker();

            let arrowsWrap = $(".swiper-arrows-wrap")
            $(arrowsWrap).mousemove(function (event) {
                var x = event.pageX - $(this).offset().left;
                var y = event.pageY - $(this).offset().top;
                $(".swiper-arrows-wrap .follow-img").css('left', `${x}px`)
                $(".swiper-arrows-wrap .follow-img").css('top', `${y}px`)
            });
        }
        */
        if ($('.slideshowSwiper').length > 0) {

            const breakpointSlideshow = window.matchMedia('(max-width:767px)');

            let swipers = []; // Array to store Swiper instances

            const breakpointSlideshowChecker = function () {
                $('.slideshowSwiper').each(function (index, element) {
                    const $sliderWrap = $(element).closest('.slideshow-popup'); // Find the closest slideshowWrap for scoping

                    // Destroy Swiper instance if the breakpoint matches
                    if (breakpointSlideshow.matches === true) {
                        if (swipers[index] !== undefined) swipers[index].destroy(true, true);
                        swipers[index] = undefined; // Reset the instance
                    } else if (breakpointSlideshow.matches === false) {
                        // Initialize Swiper only if not already initialized
                        if (swipers[index] === undefined) {
                            enableSwiper(element, $sliderWrap, index);
                        }
                    }
                });
            };

            const enableSwiper = function (element, $sliderWrap, index) {
                // Use navigation and pagination scoped within the current sliderWrap
                swipers[index] = new Swiper(element, {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    loop: true,
                    speed: 1000,
                    spaceBetween: 20,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        nextEl: $sliderWrap.find('.swiper-arrow-next')[0],
                        prevEl: $sliderWrap.find('.swiper-arrow-prev')[0],
                    },
                    pagination: {
                        el: $sliderWrap.find('.swiper-slideshow-pagination')[0],
                        clickable: true,
                    }
                });
            };

            // Check on load and listen for resize
            breakpointSlideshow.addListener(breakpointSlideshowChecker);
            breakpointSlideshowChecker();

            // Cursor-following functionality for arrows
            $(".swiper-arrows-wrap").mousemove(function (event) {
                var x = event.pageX - $(this).offset().left;
                var y = event.pageY - $(this).offset().top;
                $(this).find('.follow-img').css({
                    left: `${x}px`,
                    top: `${y}px`
                });
            });
        }

        // Multiple sliders

        // SLIDER POPUP
        if ($('.slideshow-popup .close').length) {
            $('.slideshow-popup .close').on('click', function () {
                $('.slideshow-popup').fadeOut()
            })

            $('.view-slideshow').on('click', function () {
                $('.slideshow-popup').fadeIn()
            })


            // Additional images gallery
            $('.open-popup').on('click', function () {
                $('.slideshow-popup').fadeIn()
                slideshowSwiper.slideTo(parseInt($(this).attr('data-slide')) + 1, 0);
            })


        }


        // SLIDER POPUP
        // ----------------------------------------------------------- PROJECT PAGE

        if ($('.slideshowBlockSwiper').length > 0) {

        }

        // ----------------------------------------------------------- CONTACT PAGE

        if ($('.swiperContact').length) {
            const mySwiper = new Swiper('.swiperContact', {
                // Swiper owns image loading for its own slides: the images keep the
                // browser's loading="lazy" and this preloads the slides either side, so
                // the next one is ready before the swipe rather than appearing after it.
                lazyPreloadPrevNext: 1,
                direction: 'vertical',
                speed: 800,
                allowTouchMove: false,
                mousewheel: true,
                // breakpoints: {
                //     1024: {
                //         mousewheel: true,
                //     }
                // }
            });


            const num_slides = mySwiper.slides.length

            $('.map-1-buttom').on('click', function () {
                if (num_slides == 2) mySwiper.slideTo(0)
                else mySwiper.slideTo(1)
            })
            $('.map-2-buttom').on('click', function () {
                //mySwiper.slideTo(2)
                if (num_slides == 2) mySwiper.slideTo(1)
                else mySwiper.slideTo(2)
            })
        }

        // ----------------------------------------------------------- CONTACT PAGE

        // ----------------------------------------------------------- JOURNAL FILTER / PRODUCTS ORDER BY
        const closeCustomSelect = function (select, restoreFocus) {
            const trigger = select.querySelector('.custom-select__trigger');
            select.classList.remove('open');

            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');

                if (restoreFocus) {
                    trigger.focus();
                }
            }
        };

        const openCustomSelect = function (select) {
            const trigger = select.querySelector('.custom-select__trigger');
            select.classList.add('open');

            if (trigger) {
                trigger.setAttribute('aria-expanded', 'true');
            }
        };

        const toggleCustomSelect = function (select) {
            if (select.classList.contains('open')) {
                closeCustomSelect(select, false);
            } else {
                openCustomSelect(select);
            }
        };

        const getCustomOptions = function (select) {
            return Array.from(select.querySelectorAll('.custom-option'));
        };

        const focusCustomOption = function (select, fallbackToLast) {
            const options = getCustomOptions(select);
            const activeOption = select.querySelector('.custom-option[aria-selected="true"], .custom-option.active');

            if (!options.length) {
                return;
            }

            (activeOption || options[fallbackToLast ? options.length - 1 : 0]).focus();
        };

        const focusAdjacentCustomOption = function (option, direction) {
            const select = option.closest('.custom-select');
            const options = select ? getCustomOptions(select) : [];
            const currentIndex = options.indexOf(option);

            if (!options.length || currentIndex < 0) {
                return;
            }

            options[(currentIndex + direction + options.length) % options.length].focus();
        };

        document.querySelectorAll('.custom-select-wrapper').forEach(wrapper => {
            const select = wrapper.querySelector('.custom-select');
            const trigger = wrapper.querySelector('.custom-select__trigger');

            if (!select || !trigger || wrapper.hasAttribute('onclick')) {
                return;
            }

            trigger.addEventListener('click', function (e) {
                e.stopPropagation();
                toggleCustomSelect(select);
            });

            trigger.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleCustomSelect(select);
                } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                    e.preventDefault();
                    openCustomSelect(select);
                    focusCustomOption(select, e.key === 'ArrowUp');
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    closeCustomSelect(select, true);
                }
            });
        });

        const activateCustomOption = function (option, restoreFocus) {
            const select = option.closest('.custom-select');
            const alreadySelected = option.classList.contains('selected');
            const value = option.getAttribute('data-value');

            if (!alreadySelected) {
                const label = option.innerText;

                option.parentNode.querySelector('.custom-option.selected')?.classList.remove('selected');
                option.parentNode.querySelectorAll('.custom-option[aria-selected="true"]').forEach(selectedOption => {
                    selectedOption.setAttribute('aria-selected', 'false');
                });
                option.classList.add('selected');
                option.setAttribute('aria-selected', 'true');

                if (select) {
                    const triggerLabel = select.querySelector('.custom-select__trigger span');

                    if (triggerLabel) {
                        triggerLabel.textContent = label;
                    }
                }
            }

            // Always close the dropdown, even when reselecting the current option.
            if (select) {
                closeCustomSelect(select, restoreFocus);
            }

            // Only navigate when a new option is chosen (the current one is already applied).
            if (!alreadySelected && value) {
                window.location.href = value;
            }
        };

        document.querySelectorAll('.custom-option').forEach(option => {
            option.addEventListener('click', function () {
                activateCustomOption(this, false);
            });

            option.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    activateCustomOption(this, true);
                } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    focusAdjacentCustomOption(this, 1);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    focusAdjacentCustomOption(this, -1);
                } else if (e.key === 'Escape') {
                    const select = this.closest('.custom-select');

                    if (select) {
                        e.preventDefault();
                        closeCustomSelect(select, true);
                    }
                }
            });
        });

        if ($('.custom-select').length) {
            window.addEventListener('click', function (e) {
                document.querySelectorAll('.custom-select.open').forEach(select => {
                    if (!select.contains(e.target)) {
                        closeCustomSelect(select);
                    }
                });
            });
        }
        // ----------------------------------------------------------- JOURNAL FILTER / PRODUCTS ORDER BY


        // ----------------------------------------------------------- SWIPPER
        /*
        if($('.swiper-projects').length){
            const swiperTextSlideshow = new Swiper('.swiper-projects', {
    
                // Swiper owns image loading for its own slides: the images keep the
    
                // browser's loading="lazy" and this preloads the slides either side, so
    
                // the next one is ready before the swipe rather than appearing after it.
    
                lazyPreloadPrevNext: 1,
    
                watchOverflow: true, // to remove arrow is there is only 1 slide
                loop: $(".swiper-projects").length != 1, // watchOverflow works only if loop is disabled, so we disable it if only 1 slide
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                on: {
                    slideChangeTransitionStart: function () {
                        // Pause all Vimeo videos on slide change
                        var iframes = document.querySelectorAll('.swiper-slide iframe');
                        iframes.forEach(function (iframe) {
                            var player = new Vimeo.Player(iframe);
                            player.pause();
                        });
                    }
                }
            });
        }
        */
        // ----------------------------------------------------------- SWIPPER


        // ----------------------------------------------------------- ACCORDION
        $('.accordion_container').click(function () {
            if ($(this).find(".accordion_body").is(':visible')) {
                $(this).find(".accordion_body").slideUp(300);
                $(this).removeClass('acc_opened')
            } else {
                $('.acc_opened').find('.accordion_body').slideUp(300);
                $('.acc_opened').removeClass('acc_opened')
                $(this).find(".accordion_body").slideDown(300);
                $(this).addClass('acc_opened')
            }
        })
        /*
        <div class="accordion-wrap">
                <?php 
                    $accordion = get_field('accordion');
                    foreach ($accordion as $block): 
                ?>
                <div class="accordion_container">
                    <div class="accordion_head">
                        <h3><?= $block['title'] ?></h3>
                        <div class="arrow_accordion"></div>
                    </div>
                    <div class="accordion_body font-body" style="display: none;">
                        <?= $block['copy'] ?>
                    </div>
                </div>
                <?php endforeach; ?>
            </div>
        */
        // ----------------------------------------------------------- ACCORDION

        // ----------------------------------------------------------- FADE MEDIA ELEMENTS
        if ($('.fade-media-element').length) {

            if ($('.fade-media-element').attr('data-type') == 'video') {

                const fadeMediaVideo = async () => {
                    let video = document.createElement('video');
                    video.preload = 'auto';
                    video.muted = true;
                    video.autoplay = true;
                    video.loop = true;
                    video.setAttribute('playsinline', true);
                    video.setAttribute('webkit-playsinline', true);
                    video.style.opacity = 0;
                    let source = document.createElement('source');
                    source.src = await loadVideoSrc($('.fade-media-element').attr('data-src'));
                    source.type = $('.fade-media-element').attr('data-videoType');
                    $(video).prepend(source);
                    $('.fade-media-element').prepend(video);
                    $(video).addClass('loaded')


                }
                fadeMediaVideo()


            } else if ($('.fade-media-element').attr('data-type') == 'image') {

                const fadeMediaImage = async () => {
                    let image = document.createElement('img');
                    image.style.opacity = 0;
                    image.src = await loadImageSrc($('.fade-media-element').attr('data-src'));
                    image.srcset = $('.fade-media-element').attr('data-srcset');
                    image.classList.add("fullscreen");
                    $('.fade-media-element').prepend(image);
                    $(image).addClass('loaded')

                }
                fadeMediaImage()

            }

        }
        // ----------------------------------------------------------- FADE MEDIA ELEMENTS

        // observeIntersection -----------------------------------------------------------
        let imageOptions = {
            root: null,
            rootMargin: '0px 0px 100px 0px',
            threshold: 0.2
            //rootMargin: '0px 0px -200px 0px',
            //threshold: 0.2
        }
        // The image half of this observer is gone: no template emits
        // img.lazy-wonton any more, since lazy-image.php now renders through
        // wp_get_attachment_image() and the lazy-load library handles deferral.
        // Video keeps its observer below -- loading="lazy" is not valid on
        // <video>, and autoplay overrides preload="none".

        observeIntersection('video.lazy-wonton', imageOptions, async videoElement => {
            let source = document.createElement('source');
            source.src = await loadVideoSrc(videoElement.dataset.src);
            source.type = videoElement.dataset.mime_type;
            $(videoElement).prepend(source);
            $(videoElement).addClass('loaded')
        });


        // EXAMPLE 1:
        /*
        div class="img-wrap">
            <?php
            $image_src = $image['sizes']['medium'];
            $image_srcset = wp_get_attachment_image_srcset($image['id'], 'medium');	
            ?>
            <img src="" data-src="<?= $image_src ?>" data-srcset="<?= $image_srcset ?>" class="lazy-wonton">
        </div>
    
        */

        // EXAMPLE 2:
        /*
        <?php 
        $image_src = $image['sizes']['medium'];
        $image_srcset = wp_get_attachment_image_srcset($image['id'], 'medium'); 
        $image_attributes = wp_get_attachment_image_src( $image['id'], 'medium' );
        ?>
    
        <div class="img-wrap aspect-ratio-crop" style="--aspect-ratio-crop:<?= $image_attributes[1] ?>/<?= $image_attributes[2] ?>">
            <img data-src="<?= $image_attributes[0] ?>" data-srcset="<?= $image_srcset ?>" class="lazy-wonton" alt="" title="" >
        </div>
        */




        // VIDEO - TODO
        //Ex: <div class="g-video" data-src="/assets/img/dummy/video/Murrurundi Entrance_1.mp4"></div>
        // let video = document.querySelector('.g-video');
        // initVideo()
        // function initVideo() {
        //     player = document.createElement('video');
        //     player.classList.add("place-image");
        //     player.preload = 'auto';
        //     player.muted = true;
        //     player.autoplay = true;
        //     player.loop = true;
        //     player.setAttribute('playsinline', true);
        //     player.setAttribute('webkit-playsinline', true);
        //     player.src = video.getAttribute('data-src');
        //     video.appendChild(player);
        // }

        // observeIntersection -----------------------------------------------------------


        // DESTROY SLIDER ON MOBILE AND CREAT AGAIN ON DESKTOP
        /*$('.dragscroll').kinetic({
            filterTarget: function (target, e) {
                if (!/down|start/.test(e.type)) {
                    return !(/area|a|input/i.test(target.tagName));
                }
            }
        });
    
        if ($('.swiper').length > 0) {
            // breakpoint where swiper will be destroyed
            // and switches to a dual-column layout
            const breakpoint = window.matchMedia('(max-width:768px)');
            // keep track of swiper instances to destroy later
            let mySwiper;
    
            const breakpointChecker = function () {
                //console.log('breakpointChecker');
                //console.log('breakpointChecker ', breakpoint.matches);
                // if larger viewport and multi-row layout needed
                if (breakpoint.matches === true) {
                    // clean up old instances and inline styles when available
                    if (mySwiper !== undefined) mySwiper.destroy(true, true);
                    // or/and do nothing
    
                    $('.dragscroll').kinetic('detach');
    
                    return;
                    // else if a small viewport and single column layout needed
                } else if (breakpoint.matches === false) {
                    // fire small viewport version of swiper
                    return enableSwiper();
                }
    
    
            };
    
            const enableSwiper = function () {
                mySwiper = new Swiper(".swiper", {
                    // Swiper owns image loading for its own slides: the images keep the
                    // browser's loading="lazy" and this preloads the slides either side, so
                    // the next one is ready before the swipe rather than appearing after it.
                    lazyPreloadPrevNext: 1,
                    slidesPerView: "auto",
                    spaceBetween: 40,
                    freeMode: true,
                    loop: true,
                    grabCursor: true,
                });
                $('.dragscroll').kinetic('attach');
            };
    
            // keep an eye on viewport size changes
            breakpoint.addListener(breakpointChecker);
            // kickstart
            breakpointChecker();
    
        }
        */

        /*
        //DESTROY SCLIK ON MOBILE AND CREAT AGAIN ON DESKTOP
        const settings = {
                autoplay: true,
                autoplaySpeed: 5000,
                fade: false,
                arrows: false,
                adaptiveHeight: false,
                dots: false,
                responsive: [
                    {
                      breakpoint: 767,
                      settings:"unslick"
                    }
                  ]
        };
        const sl = $('.slickProject').slick(settings);
        $(window).on('resize', function() {
           if( $(window).width() > 767 &&  !sl.hasClass('slick-initialized')) {
                 $('.slickProject').slick(settings);
            }
        });
        */

        /*
        var resizeId;
        $(window).resize(function() {
            clearTimeout(resizeId);
            resizeId = setTimeout(doneResizing, 500);
        });
    
        function doneResizing(){
            //whatever we want to do
        }
        */

        /*
        //EJ: full screen menu...we want to close it on click any place but the menu at the center
        $(document).mouseup(function(e) 
        {
            if($('.menu-wrapper').is(":visible")){
                var container = $(".menu-wrapper #nav");
                // if the target of the click isn't the container nor a descendant of the container
                if (!container.is(e.target) && container.has(e.target).length === 0) 
                {
                    $('.menu-wrapper').fadeToggle();
                }
            }
        });
        */



    });

}(window.jQuery || window.$));



function loadImageSrc(src) {
    return new Promise(resolve => {
        const image = new Image();
        image.src = src;
        image.onload = function () {
            resolve(src);
        };
    });
}

function loadVideoSrc(src) {
    return new Promise(resolve => {
        const video = document.createElement('video');
        video.onloadedmetadata = function () {
            resolve(src);
        };
        video.src = src;
    });
}

// https://connorsmyth.com/lazy-loading-images-in-wordpress/

function observeIntersection(selector, options, callback) {

    // let options = {
    //     root: null,
    //     rootMargin: '0px 0px -200px 0px',
    //     threshold: 0.2
    // }

    const observer = new IntersectionObserver(components => {
        components.forEach(component => {
            if (component.isIntersecting && typeof callback === 'function') {
                callback(component.target);
                observer.unobserve(component.target);
            }
        });
    }, options);

    observer.POLL_INTERVAL = 100; // Time in milliseconds.
    Array.from(document.querySelectorAll(selector)).forEach(
        observer.observe.bind(observer)
    );
    return observer;
}

function safari100vhHack() {
    //Safari mobile hack for 100vh
    // CSS = height: calc(var(--vh, 1vh) * 100) !important;

    let vh = window.innerHeight * 0.01;
    /*let vw = window.innerWidth * 0.01;*/
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    /* document.documentElement.style.setProperty('--vw', `${vw}px`);*/
    window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        /*let vw = window.innerWidth * 0.01;
         document.documentElement.style.setProperty('--vw', `${vw}px`);*/
    });
    //Safari mobile hack for 100vh
}


function $_GET(param) {
    var vars = {};
    window.location.href.replace(location.hash, '').replace(
        /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
        function (m, key, value) { // callback
            vars[key] = value !== undefined ? value : '';
        }
    );

    if (param) {
        return vars[param] ? vars[param] : null;
    }
    return vars;
}

function empty(val) {

    // test results
    //---------------
    // []        true, empty array
    // {}        true, empty object
    // null      true
    // undefined true
    // ""        true, empty string
    // ''        true, empty string
    // 0         false, number
    // true      false, boolean
    // false     false, boolean
    // Date      false
    // function  false

    if (val === undefined)
        return true;

    if (typeof (val) == 'function' || typeof (val) == 'number' || typeof (val) == 'boolean' || Object.prototype.toString.call(val) === '[object Date]')
        return false;

    if (val == null || val.length === 0)        // null or 0 length array
        return true;

    if (typeof (val) == "object") {
        // empty object

        var r = true;

        for (var f in val)
            r = false;

        return r;
    }

    return false;
}

function convertSvg() {
    jQuery('img.svg').each(function () {
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
}

// ----------------------------------------------------------- PARTNER HOVER VIDEO
(function () {
    var cards = document.querySelectorAll('.partner-card.has-video');
    if (!cards.length) return;

    // Only wire up hover playback on devices that actually hover (desktop pointers).
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    cards.forEach(function (card) {
        var video = card.querySelector('.partner-card-video');
        if (!video) return;

        var sourceLoaded = false;
        var hovering = false;

        function ensureSource() {
            if (sourceLoaded) return;
            sourceLoaded = true;
            var source = document.createElement('source');
            source.src = video.getAttribute('data-src');
            source.type = video.getAttribute('data-mime') || 'video/mp4';
            video.appendChild(source);
            video.load();
        }

        // Reveal only once a frame has actually decoded, so the poster image
        // crossfades to the video instead of flashing black on first hover.
        video.addEventListener('playing', function () {
            if (hovering) {
                video.classList.add('is-playing');
            }
        });

        card.addEventListener('mouseenter', function () {
            hovering = true;
            ensureSource();
            var playing = video.play();
            if (playing && playing.catch) {
                playing.catch(function () {});
            }
        });

        card.addEventListener('mouseleave', function () {
            hovering = false;
            video.classList.remove('is-playing');
            video.pause();
            // Reset so the next hover starts from the first frame.
            try {
                video.currentTime = 0;
            } catch (e) {}
        });
    });
})();
